export default __webpack_public_path__ + "static/media/AAPG-Pivoting-6.1913b28a.jpg";